<router-outlet></router-outlet>
@if (commonService.isLoading) {
  <div class="spinner">
    <mat-progress-spinner [color]="'accent'" [mode]="'indeterminate'"></mat-progress-spinner>
    <img src="../assets/loader.png" style="position: absolute;width: 90px;" alt="Loading...">
  </div>
}
